import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { Observable } from 'rxjs';

@Pipe({
	name: 'i18n',
	standalone: false,
})
export class I18nPipe implements PipeTransform {
	constructor(private localizationService: LocalizationService) {}

	transform(key: string): Observable<string> {
		return this.localizationService.getTranslationByKeyAsync(key);
	}

	translate(key: string): string {
		return this.localizationService.getTranslationByKey(key);
	}
}
